import { Stack, styled } from "@mui/material";
import { CheckboxInput, RadioInput, SelectInput, TextInput } from "../Form";
import { toPx } from "../MuiHelpers";
import { BodyTextM, HeadingXS } from "../Typography";

const INPUT_MAX_WIDTH_PX = 328;

export const AmlSelectInput = styled(SelectInput)(({ theme }) =>
    theme.unstable_sx({
        maxWidth: toPx(INPUT_MAX_WIDTH_PX),
    }),
);

export const QuestionHeader = styled(HeadingXS)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(3),
        mt: theme.spacing(2),
        // Fix nested typography inheritance issue
        "& span.MuiTypography-root": {
            fontFamily: "inherit",
        },
    }),
);

export const FormGroup = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(1),
    }),
);

export const ContainerStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(7),
        mt: theme.spacing(6),
    }),
);

export const AmlCheckBoxInput = styled(CheckboxInput)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(1),
        "&.MuiCheckbox-root": {
            py: theme.spacing(2),
        },
    }),
);

export const AmlRadioInput = styled(RadioInput)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(1),
        "&.MuiRadio-root": {
            py: theme.spacing(2),
        },
    }),
);

export const AmlTextInput = styled(TextInput)(({ theme }) =>
    theme.unstable_sx({
        maxWidth: toPx(INPUT_MAX_WIDTH_PX),
    }),
);

export const AmlBasicLabel = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(1),
    }),
);
